module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"fromOrigin":"中心部から <b>{distance}km</b>","seeDetails":"詳細を見る","contact-warehouse":"<span>この倉庫に</span>問い合わせ"},"en":{"fromOrigin":"<b>{distance}km</b> from origin","seeDetails":"Show details","contact-warehouse":"Contact<span> this warehouse</span>"}}')
  delete Component.options._Ctor
}
